import { render, staticRenderFns } from "./DisplayItemRelation.vue?vue&type=template&id=2190f83e&"
import script from "./DisplayItemRelation.vue?vue&type=script&lang=js&"
export * from "./DisplayItemRelation.vue?vue&type=script&lang=js&"
import style0 from "./DisplayItemRelation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports